import React from "react";
import styled from "@emotion/styled";
import Colors from "../../styles/Colors";
import Typography from "../../styles/Typography";

interface Props {
    type?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p",
    getRef?: any,
    children: string,
    color?: string,
    size?: string | null,
    textAlign?: string,
}

const Text = (
    {
        type = "p",
        children,
        color = Colors.darkGrey,
        size = null,
        getRef,
        textAlign = "center",
        ...props
    }: Props
) => {
    switch (type) {
        case "h1":
            return <H1 ref={getRef} {...props} textAlign={textAlign} color={color} size={size}>{children}</H1>
        case "h2":
            return <H2 ref={getRef} {...props} textAlign={textAlign} color={color} size={size}>{children}</H2>
        case "h3":
            return <H3 ref={getRef} {...props} textAlign={textAlign} color={color} size={size}>{children}</H3>
        case "h4":
            return <H4 ref={getRef} {...props} textAlign={textAlign} color={color} size={size}>{children}</H4>
        case "h5":
            return <H5 ref={getRef} {...props} textAlign={textAlign} color={color} size={size}>{children}</H5>
        case "h6":
            return <H6 ref={getRef} {...props} textAlign={textAlign} color={color} size={size}>{children}</H6>
        case "p":
            return <P ref={getRef} {...props} textAlign={textAlign} color={color} size={size}>{children}</P>
    }

}

export default Text

interface TextProps {
    color: string,
    size: string | null,
    textAlign: string,
}

const H1 = styled.h1<TextProps>`
  text-align: ${props => props.textAlign};
  margin: 0;
  color: ${props => props.color ? props.color : Colors.darkGrey};
  font-size: ${props => props.size ? props.size : Typography.h1};
`

const H2 = styled.h2<TextProps>`
  text-align: ${props => props.textAlign};
  margin: 0;
  color: ${props => props.color ? props.color : Colors.darkGrey};
  font-size: ${props => props.size ? props.size : Typography.h2};
`

const H3 = styled.h3<TextProps>`
  text-align: ${props => props.textAlign};
  margin: 0;
  color: ${props => props.color ? props.color : Colors.darkGrey};
  font-size: ${props => props.size ? props.size : Typography.h3};
`

const H4 = styled.h4<TextProps>`
  text-align: ${props => props.textAlign};
  margin: 0;
  color: ${props => props.color ? props.color : Colors.darkGrey};
  font-size: ${props => props.size ? props.size : Typography.h4};
`

const H5 = styled.h5<TextProps>`
  text-align: ${props => props.textAlign};
  margin: 0;
  color: ${props => props.color ? props.color : Colors.darkGrey};
  font-size: ${props => props.size ? props.size : Typography.h5};
`

const H6 = styled.h6<TextProps>`
  text-align: ${props => props.textAlign};
  margin: 0;
  color: ${props => props.color ? props.color : Colors.darkGrey};
  font-size: ${props => props.size ? props.size : Typography.h6};
`

const P = styled.p<TextProps>`
  text-align: ${props => props.textAlign};
  margin: 0;
  color: ${props => props.color ? props.color : Colors.darkGrey};
  font-size: ${props => props.size ? props.size : Typography.p};
`


